/**
 * @deprecated Since version 2.0.0 - Use TanStack Query instead
 * 
 * This file contains legacy NgRx effects that are no longer maintained.
 * 
 * Migration Guide:
 * - Replace effects with TanStack Query hooks
 * - Use `useWarehousesList()` or `useUbicacionesList()` for list operations
 * - Error handling is built into TanStack Query via `query.isError()` and `query.error()`
 * - Success callbacks use mutation `onSuccess` option
 * 
 * Example migration:
 * ```typescript
 * // OLD (NgRx Effect):
 * loadList$ = createEffect(() =>
 *   this.actions$.pipe(
 *     ofType(LocationActionTypes.LoadList),
 *     exhaustMap(() => this.service.getList().pipe(
 *       map(data => new LoadListComplete(data)),
 *       catchError(error => of(new LoadListError(error)))
 *     ))
 *   )
 * );
 * 
 * // NEW (TanStack Query):
 * locationsQuery = inject(WarehousesQueriesService).useWarehousesList(filters);
 * // Automatic: loading state, error handling, cache management, refetch logic
 * ```
 * 
 * See documentation: libs/kanzi-location/docs/FASE-1-RESUMEN.md
 */
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { tap, map, exhaustMap, catchError, concatMap } from 'rxjs/operators';
import { LocationListService } from '@kanzi-apes/kanzi-locations';
import { AlertService } from '@kanzi-apes/kanzi-alerts';
import { LocationFilterModel } from '@kanzi-apes/kanzi-models';

import {
  LoadList,
  LoadListComplete,
  LoadListError,
  LocationActionTypes,
} from '../actions';

/**
 * @deprecated Use TanStack Query services instead
 */
@Injectable()
export class LocationListEffects {
  loadList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActionTypes.LoadList),
      map((action: LoadList) => action.payload),
      concatMap((filter: LocationFilterModel) =>
        this.listService.getlocationList(filter).pipe(
          map((response) => {
            return new LoadListComplete(response)}),
          catchError((error) => of(new LoadListError(error)))
        )
      )
    )
  );

  loadListError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LocationActionTypes.LoadListError),
        tap((action: LoadListError) => {
          this.alertService.error(action.payload);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private listService: LocationListService,
    private alertService: AlertService,
  ) {}
}
